import config from 'devextreme/core/config';
import { devextremeLicense } from 'license/devextreme';
// React 19 Migration: Updated from ReactDOM.render to createRoot API
import { createRoot } from 'react-dom/client';
import './styles/styles.scss';
import { storeVars } from '@archre2/react-core';
import 'devextreme/dist/css/dx.light.css';
// import application from 'modules/app';
import configuration from './config';
import App from 'modules/app';

storeVars.set('ClientInfoSettings', {
  uri: configuration.API.URI,
  timeout: configuration.API.TIMEOUT,
});
storeVars.setDebug(configuration.DEBUG);
config({ licenseKey: devextremeLicense });
//eslint-disable-next-line no-shadow
// application(history, 'root');

// React 19 Migration: Replaced ReactDOM.render with createRoot for concurrent features
const container = document.getElementById('root');
if (!container) {
  throw new Error(
    'Failed to find the root element. Ensure an element with id="root" exists in index.html.'
  );
}
const root = createRoot(container);
root.render(<App />);
